<template>
  <div class="distributor-box details_box_styles">
    <!--返回按钮-->
    <div class="go-back" style="display: inline-block" @click="goBackBtn">
      <Icon class="back-icon" type="ios-arrow-back"/>
      <span class="back-txt">{{ $t('key1002627') }}</span>
    </div>
    <!--订单信息-->
    <div class="basic_information_box">
      <Card :bordered="false" dis-hover>
        <template #title>
          <h2 class="title_box">{{ $t('key1004432') }}</h2>
        </template>
        <Form class="orderInfos" ref="orderInfos" :model="orderInfos" :label-width="100" @submit.native.prevent :rules="ruleValidate">
          <Row type="flex" :gutter="gutterItem" style="width: 400px;">
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <Form-item :label="$t('key1005662')" prop="ymsPlatformAccountId" :placeholder="$t('key1005955')">
                <Select v-model="orderInfos.ymsPlatformAccountId">
                  <Option v-for="item in temuStoreList" :key="item.ymsPlatformAccountId" :value="item.ymsPlatformAccountId">{{ item.code }}</Option>
                </Select>
              </Form-item>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <Form-item :label="$t('key1004503')" prop="orderType">
                <RadioGroup v-model="orderInfos.orderType">
                  <Radio label="TEMU_P">{{ $t('key1005964') }}</Radio>
                  <Radio label="TEMU_S">{{ $t('key1005965') }}</Radio>
                </RadioGroup>
              </Form-item>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <Form-item :label="$t('key1004249')" prop="platformOrderId">
                <Input v-model.trim="orderInfos.platformOrderId" :placeholder="$t('key1005956')" clearable></Input>
              </Form-item>
            </Col>
          </Row>
        </Form>
      </Card>
    </div>
    <!--订单商品-->
    <div class="basic_information_box">
      <Card :bordered="false" dis-hover>
        <template #title>
          <h2 class="title_box">{{ $t('key1004421') }}</h2>
        </template>
        <div class="mb20">
          <Button type="primary" class="mr15" icon="md-add" @click="addProductBtn">{{ $t('key1001092') }}</Button>
          <Button icon="md-trash" :disabled="tableData.length<=0" @click="deleteProductBtn">{{ $t('key1005966') }}</Button>
        </div>
        <Table
          ref="selection"
          highlight-row
          border
          max-height="400"
          :loading="tableLoading"
          :columns="tableColumns"
          :no-data-text="$t('key1005957')"
          @on-selection-change="getSelectValue"
          :data="tableData">
        </Table>
        <div class="flex justify-content-between">
          <!--寄样订单提示-->
          <div style="color: rgb(233 18 45);font-weight: bold; font-size: 13px; position: relative;top: -2px;margin-top: 15px;">
            {{ $t('key1005967') }}<br/>
            {{ $t('key1005968') }}<br/>
            {{ $t('key1005960') + configCharacters() + $t('key1005961')}}
          </div>
          <!--商品总金额-->
          <div class="flex total_goods_box">
            <div>
              <p class="mb10">
                <span class="money_item_style text-align-right">{{ $t('key1005969') }}</span>
                <span class="goods_num_style money_item_style">{{ totalQuantityGoods }}</span>
              </p>
              <p class="mb10">
                <span class="money_item_style text-align-right">{{ $t('key1005970') }}</span>
                <span class="goods_num_style money_item_style">{{ totalWeight }}</span>
              </p>
            </div>
            <div>
              <p class="mb10">
                <span class="money_item_style text-align-right">{{ $t('key1000119') }}</span>
                <span class="goods_num_style money_item_style">{{ currencyState + ' ' + totalAmountGoods }}</span>
              </p>
              <p class="mb10">
              <span class="money_item_style text-align-right">
                 <Tooltip style="width: 30px;" placement="top-end" transfer :offset="8" :max-width="250" :content="$t('key1005958')">
                <Icon type="ios-alert-outline" color="#FD5425" size="19" style="margin:0 35px 0 8px; cursor: pointer;"/>
              </Tooltip>
                {{ $t('key1000120') }}
              </span>
                <span class="goods_num_style money_item_style">{{ currencyState + ' ' + processingFee }}</span>
              </p>
            </div>
          </div>
        </div>
      </Card>
    </div>
    <!--收货地址-->
    <div class="basic_information_box">
      <Card :bordered="false" dis-hover>
        <template #title><h2 class="title_box">{{ $t('key1005971') }}</h2></template>
        <Row type="flex" :gutter="gutterItem" v-if="Object.keys(receivingAddress).length>0">
          <Col :span="2" class="basic_item default_address_style">
            <span class="name_style" :title="receivingAddress.name">
              {{ receivingAddress.name }}
            </span>
            <i class="iconfont select_icon_style">&#xe8b7;</i>
          </Col>
          <Col :span="18" class="basic_item background_hover_style flex justify-content-center justify-content-between">
            <span class="basic_txt">{{ receivingAddress.detailedAddress }}</span>
            <div class="justify-content-center options_boxs">
               <span class="goods_num_style cursor mr15" v-if="receivingAddress.isDefault !==1 && getPermission('ymsDeliveryAddress_updateStatus')"
                 @click="setDefaultAddress(receivingAddress.ymsDeliveryAddressId)">{{ $t('key1005972') }}</span>
              <span class="goods_num_style cursor mr15" v-if="getPermission('ymsDeliveryAddress_update')" @click="setAddressBtn('edit', receivingAddress)">{{ $t('key1000985') }}</span>
              <span class="goods_num_style cursor" v-if="getPermission('delete_ymsDeliveryAddress')" @click="deleteAddressBtn(receivingAddress)">{{ $t('key1000105') }}</span>
            </div>
          </Col>
        </Row>
        <!--更多地址-->
        <div class="more_address_box" v-if="receivingAddressList.length>0">
          <h2 class="flex align-items-center cursor mb10" @click="moreAddressBtn">
            <span style="margin-right: 5px">{{ moreAddressTalg ? $t('key1005962') : $t('key1005963') }}</span>
            <Icon type="ios-arrow-down" :class="moreAddressTalg ? 'icon_rotate_style' : ''" size="20"/>
          </h2>
          <Row type="flex" :gutter="gutterItem" v-if="moreAddressTalg" class="more_address_list">
            <Col :span="18" class="basic_item background_hover_style flex justify-content-center justify-content-between cursor"
              v-for="(item, index) in receivingAddressList" :key="index">
              <div class="flex align-items-center" @click="selectAddress(item, index)">
                <div class="flex default_address_style" v-if="item.selectAddressTalg">
                  <span class="name_style pl20 pr20" :title="item.name">{{ item.name }}</span>
                  <i class="iconfont select_icon_style">&#xe8b7;</i>
                </div>
                <span class="basic_txt" v-else>{{ item.name }}</span>
                <span class="basic_txt pl20 pr20">{{ item.detailedAddress }}</span>
              </div>
              <div class="flex align-items-center options_boxs">
                <span class="goods_num_style cursor mr15" v-if="item.isDefault !==1 && getPermission('ymsDeliveryAddress_updateStatus')"
                  @click="setDefaultAddress(item.ymsDeliveryAddressId)">{{ $t('key1005972') }}</span>
                <span class="goods_num_style cursor mr15" v-if="getPermission('ymsDeliveryAddress_update')" @click="setAddressBtn('edit', item)">{{ $t('key1000985') }}</span>
                <span class="goods_num_style cursor" v-if="getPermission('delete_ymsDeliveryAddress')" @click="deleteAddressBtn(item)">{{ $t('key1000105') }}</span>
              </div>
            </Col>
          </Row>
        </div>
        <Button icon="md-add" v-if="getPermission('ymsDeliveryAddress_update')" @click="setAddressBtn('add')">{{ $t('key1001152') }}</Button>
      </Card>
    </div>
    <!--提交商品按钮操作栏-->
    <div class="submit_goods_box" :class="fixedTalg ? 'fixed_box_style': ''">
      <span>{{ $t('key1001493') }}</span>
      <span class="goods_num_style" style="font-size: 18px;">{{ currencyState }} {{ totalPayable }}</span>
      <Tooltip transfer placement="top-end" :offset="10" :max-width="450" :content="$t('key1005959')">
        <Icon type="ios-alert-outline" color="#FD5425" size="21" style="margin:0 0 0 8px; cursor: pointer;"/>
      </Tooltip>
      <Button size="large" class="mr15 ml30" @click="cancelOrderBtn">{{ $t('key1000112') }}</Button>
      <Button size="large" :disabled="placeOrderTalg" type="primary" @click="placeOrderBtn">{{ $t('key1000367') }}</Button>
    </div>
    <div style="visibility: hidden" :class="fixedTalg ? 'fixed_style' : ''"></div>
    <!--添加商品弹窗-->
    <addCommonProductModal
      ref="addCommonProduct"
      :apiUrl="apiUrl"
      :customStyle="true"
      systemType="distributor"
      :distributorShowFieldKeyList="['selection', 'goodsInfo','myInventory', 'supplierAvailableNumber', 'ymsAvailableNumber', 'suggestPrice', 'weight', 'length', 'status']"
      @updateGoodsData="updateGoodsData">
    </addCommonProductModal>
    <!--收货地址弹窗-->
    <receivingAddressModal ref="receivingAddress" @updateAddress="updateAddress"></receivingAddressModal>
    <!--条码缺失提示弹窗-->
    <barcodePromptModal ref="barcodePrompt" :orderType="orderInfos.orderType"></barcodePromptModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from '@/components/mixin/common_mixin';
import addCommonProductModal from "@/components/common/addCommonProductModal";
import receivingAddressModal from "@/components/common/receivingAddressModal.vue";
import barcodePromptModal from "@/views/distributor/components/orderManage/barcodePromptModal";
import {getReceivingAddressData, insufficientAccountBalance, setConfigCharacters} from "@/utils/common";
import {getAppClientHeight, getAppScrollContainer, getAppScrollHeight, getAppScrollTop} from "@/utils/appScroll";

export default {
  name: "addTemuOrder",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      apiUrl: api.post_ymsDistributorProductInfo_queryYmsProductGoods,
      ItemCol: 8,
      estimateFreightPrice: 0,
      placeOrderTalg: true,
      selectGoodsList: [],
      tableData: [],
      tableColumns: [
        {
          type: 'selection',
          width: 60,
          align: 'left'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000383'),
          minWidth: 200,
          align: 'left',
          render: (h, params) => {
            return v.tableProductInformation(h, params);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001102'),
          key: 'supplierAvailableNumber',
          minWidth: 120,
          align: 'left',
          render(h, params) {
            let number = params.row.supplierAvailableNumber || 0;
            return h('span', number);
          }
        },
        {
          title: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001091')}`,
          key: 'ymsAvailableNumber',
          minWidth: 120,
          align: 'left',
          render(h, params) {
            let number = params.row.ymsAvailableNumber || 0;
            return h('span', number);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001110'),
          key: 'suggestPrice',
          minWidth: 130,
          align: 'left',
          render: (h, params) => {
            return h('div', [
              h('div', v.formatCurrency(params.row.suggestPrice)),
              h('div', '(' + v.currencyState + ')')
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005944'),
          key: 'quantity',
          minWidth: 200,
          align: 'left',
          render: (h, params) => {
            return h('div', [
              h('InputNumber', {
                props: {
                  controlsOutside: true,
                  value: params.row.quantity ? params.row.quantity : null,
                  min: 1,
                  max: 999999,
                  activeChange: false,
                  formatter: value => `${parseInt(value)}`
                },
                style: {
                  width: '160px',
                  textAlign: 'left'
                },
                on: {
                  'on-change': num => {
                    if (num > 0) {
                      let weight = parseInt(num) * params.row.weight;
                      v.$set(v.tableData[params.index], 'commodityWeight', weight);
                      v.$set(v.tableData[params.index], 'quantity', parseInt(num));
                    }
                  }
                }
              })
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005945'),
          key: 'subtotal',
          minWidth: 110,
          align: 'left',
          render: (h, params) => {
            let subtotal = params.row.suggestPrice * parseInt(params.row.quantity);
            let total = v.formatCurrency(subtotal);
            v.$set(v.tableData[params.index], 'subtotal', subtotal);
            return h('div', [
              h('div', total),
              h('div', '(' + v.currencyState + ')'),
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'action',
          align: 'left',
          width: 130,
          render: (h, params) => {
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000105'),
                    color: '#FF0000',
                    show: true,
                    clickFn: () => {
                      v.tableData.splice(params.index, 1);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      processingFee: 0, // 处理费
      totalPayable: 0, // 应付总额
      totalAmountGoods: 0, // 商品总金额
      receivingAddress: {}, // 收货地址
      moreAddressTalg: false,
      receivingAddressList: [],
      totalWeight: 0, // 商品总重量
      totalQuantityGoods: 0, //商品的总数量
      fixedTalg: true,
      temuStoreList: [],
      orderInfos: {
        ymsPlatformAccountId: null,
        orderType: 'TEMU_P',
        platformOrderId: ''
      },
      ruleValidate: {
        ymsPlatformAccountId: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005946'), trigger: 'change'}
        ],
        platformOrderId: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005947'), trigger: 'blur'}
        ],
      }
    };
  },
  computed: {
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    }
  },
  mounted() {
    getAppScrollContainer().addEventListener('scroll', this.scrollBottom);
  },
  created() {
    this.initFun();
  },
  methods: {
    // 初始化接口数据
    initFun() {
      (async () => {
        await this.getTemuStoresData();
        await this.getReceivingAddressList();
      })();
    },
    // 返回列表
    goBackBtn() {
      this.$router.push({
        name: 'platformOrder',
        params: {
          platformId: 'temu'
        }
      });
    },
    // 添加商品
    addProductBtn() {
      this.$refs['addCommonProduct'].initFun();
      this.$refs['addCommonProduct'].selectTableData = this.tableData;
    },
    // 删除商品
    deleteProductBtn() {
      let new_arr = [];
      if (this.selectGoodsList.length > 0) {
        this.tableData.map((item, index) => {
          if (!this.selectGoodsList.includes(item.ymsSku)) {
            new_arr.push(item);
          }
        });
        this.tableData = new_arr;
      } else {
        this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005948'));
        return false;
      }
      this.selectGoodsList = [];
    },
    // 获取Temu平台下已启用的店铺数据
    getTemuStoresData() {
      let v = this;
      let query = {
        code: '',
        status: 1, // 已启用
        platformIds: ['temu']
      };
      v.axios.post(api.post_ymsPlatformAccount_queryYmsPlatformAccountList, query).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data && data.length > 0) {
            v.temuStoreList = data;
          }
        }
      });
    },
    // 获取收货地址列表数据
    getReceivingAddressList() {
      let v = this;
      v.receivingAddress = {};
      v.receivingAddressList = [];
      this.handerMenuStyle(true);
      getReceivingAddressData().then((data) => {
        data.map((item) => {
          if (item.isDefault === 1) {
            v.receivingAddress = item;
            v.receivingAddress.detailedAddress = v.handerAddress(item);
          }
          item['detailedAddress'] = v.handerAddress(item);
          item['selectAddressTalg'] = false;
        });
        // 默认地址
        if (Object.keys(v.receivingAddress).length <= 0) {
          v.setDefaultAddress(data[0].ymsDeliveryAddressId, true);
        }
        v.receivingAddressList = data;
      });
    },
    // 新增、编辑收货地址按钮
    setAddressBtn(type, data) {
      let receivingAddress = this.$refs.receivingAddress;
      if (type === 'add') {
        receivingAddress.receivingAddressTitle = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001152');
        if (this.receivingAddressList.length <= 0) {
          receivingAddress.receivingAddressForm.isDefault = 1;
          receivingAddress.defaultTalg = true;
        }
      } else {
        let newData = JSON.parse(JSON.stringify(data));
        receivingAddress.receivingAddressTitle = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005949');
        receivingAddress.receivingAddressForm = newData;
        receivingAddress.receivingAddressForm.mobile = newData.mobile.split('+' + newData.mobileAreaCode + ' ')[1];
        receivingAddress.receivingAddressForm.phone = newData.phone.split('+' + newData.phoneAreaCode + ' ')[1];
      }
      receivingAddress.addressStatus = type;
      receivingAddress.receivingAddressModal = true;
    },
    // 删除收货地址
    deleteAddressBtn(data) {
      let v = this;
      v.$Modal.confirm({
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005950'),
        onOk: () => {
          v.axios.delete(api.delete_ymsDeliveryAddress + `${data.ymsDeliveryAddressId}`,
            {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000489'));
              v.getReceivingAddressList();
            }
          });
        },
        onCancel: () => {
        }
      });
    },
    // 勾选列表数据
    getSelectValue(value) {
      this.selectGoodsList = [];
      if (value) {
        value.map((item) => {
          this.selectGoodsList.push(item.ymsSku);
        });
      }
    },
    // 更多地址
    moreAddressBtn() {
      this.moreAddressTalg = !this.moreAddressTalg;
    },
    // 设置默认的收货地址
    setDefaultAddress(ymsDeliveryAddressId, value) {
      let v = this;
      v.axios.put(api.put_ymsDeliveryAddress_updateStatus + `${ymsDeliveryAddressId}`).then(response => {
        if (response.data.code === 0) {
          if (!value) {
            v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000489'));
          }
          v.getReceivingAddressList();
        }
      });
    },
    // 详细地址的处理
    handerAddress(data) {
      let privacyMobile = data.mobile.replace(/(\d{3})\d*(\d{4})/, "$1****$2");
      return data.name + ' ' + data.state + ' ' + data.city + ' ' + data.county + ' ' + data.streetAddress + ' ' + privacyMobile;
    },
    // 选中地址
    selectAddress(item, index) {
      this.receivingAddressList.map((item, idx) => {
        item['selectAddressTalg'] = false;
        if (idx === index) {
          this.receivingAddress = item;
          this.$set(this.receivingAddressList[index], 'selectAddressTalg', true);
        }
      });
      this.setPrice();
    },
    // 更新收货地址
    updateAddress() {
      this.getReceivingAddressList();
    },
    // 处理选中的商品数据
    updateGoodsData(data) {
      let v = this;
      const res = new Map();
      let listData = data.reduce((list, item) => {
        if (res.has(item.ymsSku)) {
          res.get(item.ymsSku).quantity += item.quantity;
        } else {
          let obj = {...item};
          list.push(obj);
          res.set(item.ymsSku, obj);
        }
        return list;
      }, []);
      listData.map((item) => {
        item['commodityWeight'] = item.weight * item.quantity;
      });
      v.tableData = listData;
      v.updateTableDom('selection');
    },
    // 取消订单
    cancelOrderBtn() {
      let v = this;
      v.$Modal.confirm({
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005951'),
        content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005952'),
        okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
        cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005953'),
        onOk: () => {
          v.goBackBtn();
        },
        onCancel: () => {
        }
      });
    },
    // 校验无标签商品
    verificationUnlabeledGoods() {
      let v = this;
      return new Promise(resolve => {
        let ymsProductGoodsIds = v.tableData.map((item) => {
          return item.ymsProductGoodsId;
        });
        let query = {
          ymsPlatformAccountId: v.orderInfos.ymsPlatformAccountId,
          ymsProductGoodsIds: ymsProductGoodsIds,
          labelType: v.orderInfos.orderType
        };
        v.axios.post(api.post_ymsThirdPlatformProductLabel_api_checkNotLabel, query).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            if (data && data.length > 0) {
              v.$refs['barcodePrompt'].barcodePromptData(data);
            } else {
              resolve(true);
            }
          }
        });
      });
    },
    // 提交订单
    placeOrderBtn() {
      let v = this;
      if (v.tableData.length <= 0 || Object.keys(v.receivingAddress).length <= 0) {
        v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005954'));
        return false;
      }
      let query = {
        buyerAccountId: v.receivingAddress.name,
        buyerAddress1: v.receivingAddress.streetAddress,
        buyerCity: v.receivingAddress.city,
        buyerCountryCode: v.receivingAddress.countryCode,
        buyerEmail: v.receivingAddress.email,
        buyerMobile: v.receivingAddress.mobile,
        buyerName: v.receivingAddress.name,
        buyerPhone: v.receivingAddress.phone,
        buyerPostalCode: v.receivingAddress.postalCode,
        buyerState: v.receivingAddress.state,
        orderType: v.orderInfos.orderType,
        platformId: 'temu',
        platformOrderId: v.orderInfos.platformOrderId,
        ymsPlatformAccountId: v.orderInfos.ymsPlatformAccountId,
        ymsPlatformOrderTransactionBos: []
      };
      v.tableData.map((item) => {
        query.ymsPlatformOrderTransactionBos.push({
          quantity: item.quantity,
          ymsProductGoodsId: item.ymsProductGoodsId
        });
      });
      v.$refs['orderInfos'].validate((valid) => {
        if (valid) {
          v.verificationUnlabeledGoods().then(() => {
            v.axios.post(api.post_ymsPlatformOrder_createPlatformOrder, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
              if (response.data.code === 0) {
                v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000489'));
                v.goBackBtn();
              } else if (response.data.code === 111195) {
                insufficientAccountBalance(v);
              } else {
                setTimeout(() => {
                  v.goBackBtn();
                }, 1000);
              }
            });
          });
        }
      });
    },
    // 全部移除商品时，重置数据
    resetData() {
      this.selectGoodsList = [];
      this.processingFee = 0;
      this.totalPayable = 0;
      this.totalAmountGoods = 0;
      this.totalWeight = 0;
      this.totalQuantityGoods = 0;
      this.placeOrderTalg = true;
    },
    // 监听是否滚动到底部
    scrollBottom() {
      let talg = 200;
      let v = this;
      if (!v.fixedTalg) {
        v.fixedTalg = true;
      }
        let scrollContainer = getAppScrollContainer();
        let scrollTop = getAppScrollTop(scrollContainer);
        let clientHeight = getAppClientHeight(scrollContainer);
        let scrollHeight = getAppScrollHeight(scrollContainer);
      if (scrollTop + clientHeight >= scrollHeight - talg) {
        v.fixedTalg = false;
      }
    },
    // 处理侧边栏菜单留白的问题
    handerMenuStyle(value) {
      let v = this;
      v.$nextTick(() => {
        let dom = [...document.querySelectorAll("div[id='distributorSidebarBox']")];
        if (dom && dom.length > 0) {
          dom[0].style.height = value ? 'initial' : '100vh';
        }
      });
    },
    // 获取试算价格
    setPrice() {
      let v = this;
      let _priceTrialGoodsBoList = v.tableData.map(i => {
        return {
          quantity: i.quantity,
          ymsProductGoodsId: i.ymsProductGoodsId
        };
      });
      v.axios.post(api.post_ymsProductInfo_api_priceTrial + '?fresh=KEEPNEW', {
        countryCode: v.receivingAddress.countryCode,
        priceTrialGoodsBoList: _priceTrialGoodsBoList,
        shippingMethodId: null,
        ymsDistributorMerchantId: v.$store.state.erpConfig.merchant.merchantId
      }).then(response => {
        if (response.data.code === 0) {
          v.totalAmountGoods = response.data.datas.goodsPrice;
          v.processingFee = response.data.datas.handlePrice;
          v.estimateFreightPrice = response.data.datas.estimateFreightPrice;
          v.totalPayable = response.data.datas.totalPrice;
        }
      });
    }
  },
  //页面离开后销毁监听事件
  destroyed() {
    this.handerMenuStyle(false);
    getAppScrollContainer().removeEventListener('scroll', this.scrollBottom);
  },
  watch: {
    // 监听商品数据
    tableData: {
      handler(data) {
        if (data.length > 0) {
          this.placeOrderTalg = false;
          // 商品的总重量
          this.totalWeight = data.reduce(
            (pre, cur) => {
              return pre + cur.commodityWeight;
            }, 0);

          // 商品总数量
          this.totalQuantityGoods = data.reduce(
            (pre, cur) => {
              return pre + cur.quantity;
            }, 0);
          this.setPrice();
        } else {
          this.resetData();
        }
      },
      deep: true
    }
  },
  components: {
    addCommonProductModal,
    receivingAddressModal,
    barcodePromptModal
  }
};
</script>

<style lang="less" scoped>
.details_box_styles {
  .total_goods_box {
    margin: 30px 115px 20px 0;
    justify-content: flex-end;
  }

  .money_item_style {
    display: inline-block;
    min-width: 120px;
  }

  .goods_num_style {
    color: #FD5425;
    font-weight: bold;
    font-size: 14px;
    min-width: 94px;
  }

  .submit_goods_box {
    width: 100%;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 10px 90px 10px 0;
    margin-bottom: 12px;
  }

  .fixed_box_style {
    position: fixed;
    z-index: 1000;
    left: 0;
    bottom: 0;
    margin-bottom: 0;
    box-shadow: 0px -3px 10px 0px #c9cbce;
  }

  .fixed_style {
    height: 60px;
    margin-bottom: 12px;
  }

  .default_address_style {
    border: 2px solid #FD5425;
    box-sizing: border-box;
    text-align: center;
    height: 35px;
    line-height: 33px;
    position: relative;

    .name_style {
      display: inline-block;
      width: 100%;
      max-width: 110px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      word-wrap: break-word;
      word-break: break-all;
    }

    .select_icon_style {
      position: absolute;
      right: -1px;
      bottom: -5px;
      color: #FD5425;
      font-size: 29px;
    }
  }

  .background_hover_style {
    padding: 0 25px !important;

    .options_boxs {
      display: none;
    }

    .basic_txt {
      max-width: 900px !important;
    }

    &:hover {
      background-color: rgba(255, 83, 16, 0.0588235294117647);

      .options_boxs {
        display: flex;
      }
    }
  }

  .more_address_box {
    margin: 15px 0;

    .more_address_list {
      max-height: 350px;
      overflow-y: auto;
    }

    .icon_rotate_style {
      transform: translateY(0) rotate(180deg);
    }
  }

  /deep/ .ivu-input-number-input {
    text-align: center;
  }

  /deep/ .ivu-input-number-controls-outside-btn-disabled {
    background-color: #f3f3f3 !important;

    i {
      color: #ccc !important;
    }
  }

  .orderInfos {
    /deep/ .ivu-form-item-label {
      font-size: 14px !important;
      position: relative;
      top: 2px;
    }
  }
}

</style>
